<template>
  <div class="row justify-content-center">
    <div class="col-md-12">
         <iframe      
        src=""
        width="100%"
        frameborder="0"
        id="pdf_view_2"
      ></iframe>
      <div
        class="cv_template_1"
        id="one_ar"
        style="font-family: 'font_regular' !important"
        v-if="item"
      >
    

        </div>

      <!--Change Template Color-->
      <!-- <div class="template_color" id="temco">
        <ul>
          <li v-for="color in colors" :key="color.color">
            <button
              @click="changeColor(color.color)"
              type="button"
              :style="{ background: color.color }"
            ></button>
          </li>
        </ul>
      </div> -->
      <!--Change Template Color-->
    </div>
  </div>
</template>


<script>
/*
export default {
  props: ["item"],
  data() {
    return {
      //Template Color
      templateColor: "",
      //Template Color

      //Colors
      colors: [
        {
          color: "#DFDFDF",
        },
        {
          color: "#0EB6D8",
        },
        {
          color: "#87CCAF",
        },
        {
          color: "#CEFFB1",
        },
        {
          color: "#E4A8F3",
        },
      ],
      //Colors
    };
  },
  methods: {
    //Change Color
    changeColor(color) {
      this.templateColor = color;
    },
  },
  mounted() {
    this.changeColor(this.colors[0].color);
  },
};





*/




export default {
  data() {
    return {
      loaded: false,
      iframe: {
        src:  '',
        style: null,
        wrapperStyle: null,
      }
    }
  },
  mounted() {
    let editor = this.$refs.editor;
    this.iframe.style = {
      position: 'absolute',
      width: window.innerWidth,
      height: window.innerHeight,
      top: "100px",
      left:  "100px",
    }    
    this.iframe.wrapperStyle = {
      overflow: 'hidden',
      height:  "100px",
      width: "100px",
    } 
    this.loaded = true;
    const url = window.location.href;
    const lastParam = url.split("/").slice(-1)[0];
    document.getElementById("pdf_view_2").src = "https://sas-jobs.net/cv/vendor/test_eng.php?type=I&cv_id="+lastParam;

  }
}
</script>

<style>


/* Extra small devices (phones, 600px and down) */
@media only screen and (max-width: 600px) {
   #pdf_view_2{
  height:600px;
}
}

/* Small devices (portrait tablets and large phones, 600px and up) */
@media only screen and (min-width: 600px) {
   #pdf_view_2{
  height:750px;
}
}

/* Medium devices (landscape tablets, 768px and up) */
@media only screen and (min-width: 768px) {
   #pdf_view_2{
  height:1000px;
}
}

/* Large devices (laptops/desktops, 992px and up) */
@media only screen and (min-width: 992px) {
   #pdf_view_2{
  height:1200px;
}
}

/* Extra large devices (large laptops and desktops, 1200px and up) */
@media only screen and (min-width: 1200px) {
   #pdf_view_2{
  height:1200px;
}
}
</style>
